import { Command, HttpMethod } from "~/extensions/api";
export class GetKeiyakushaCommand extends Command {
    constructor(nyukyokeiyakuNo) {
        super(HttpMethod.Get, `common/keiyakusha/${nyukyokeiyakuNo}`);
    }
}
